import http, {SuccessEvent} from "../../common/ts/core/http";
import {EventBus} from "../../common/ts/events/EventBus";
import {FindIntent} from "./components/snippet/snippet";

function retrieveSerpClickSimilarAds(
    params: {
        id: string,
        number: number,
        ids: string,
        currentOrigin: string
        pageViewId: string,
        findIntent: FindIntent,
    },
    successEvent: SuccessEvent
) {
    let paramsWithIntent = {
        id: params.id,
        number: params.number,
        ids: params.ids,
        currentOrigin: params.currentOrigin,
        pageViewId: params.pageViewId,
        ...params.findIntent
    };

    return new http.GetEvent({
        url: `/internal/mitula/serp/similar-click`,
        params: paramsWithIntent,
        successEvent: successEvent,
    })
}

export default {
    events: {
        retrieveSerpClickSimilarAds,
    }
}
